var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkinTips.content)?_c('div',{staticClass:"checkin-rule",domProps:{"innerHTML":_vm._s(_vm.checkinTips.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }